import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperTestimonials = () => {
  new Swiper('.swiper-testimonials', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 2.4,
        spaceBetween: 10,
      },
    },
  });
};

export default swiperTestimonials;
